var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-dropdown touch"
  }, [_vm.icon ? _c('div', {
    staticClass: "input-dropdown__icon"
  }, [_c('fa', {
    attrs: {
      "icon": _vm.icon,
      "fixed-width": ""
    }
  })], 1) : _vm._e(), _vm.label ? _c('div', {
    staticClass: "input-dropdown__label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _c('div', {
    staticClass: "input-dropdown__reveal input-dropdown__button touch input-dropdown__button--active",
    on: {
      "click": function click($event) {
        _vm.isActive = !_vm.isActive;
      }
    }
  }, [_vm._v(_vm._s(_vm.value ? _vm.value : _vm.language.code === 'en' ? 'All' : 'جَميع') + " \n    "), _c('fa', {
    staticClass: "input-dropdown__button-icon",
    class: {
      'input-dropdown__button-icon--active': _vm.isActive
    },
    attrs: {
      "icon": "chevron-down"
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive,
      expression: "isActive"
    }],
    staticClass: "input-dropdown__buttons"
  }, [_c('div', {
    staticClass: "input-dropdown__heading"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._l(_vm.selections, function (selection) {
    return _c('div', {
      key: _vm.selectionKey(selection),
      staticClass: "input-dropdown__button touch",
      class: {
        'input-dropdown__button--active': _vm.isSelectionActive(selection)
      },
      on: {
        "click": function click($event) {
          return _vm.selectOption(selection);
        }
      }
    }, [_vm._v("\n        " + _vm._s(selection.label[_vm.language.code] || selection.label.en) + "\n      ")]);
  })], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }